import type { App } from 'vue';
import { computed } from 'vue';
import { createI18n } from 'vue-i18n';
import { localStg } from '@/utils/storage';
import messages from './locale';

const i18n = createI18n({
    locale: localStg.get('lang') || 'fa-IR',
    fallbackLocale: 'en',
    messages,
    legacy: false
});

// Store the translate function separately to avoid deep type instantiation
const globalT: any = (i18n as any).global.t;

/**
 * Setup plugin i18n
 *
 * @param app
 */
export function setupI18n(app: App) {
    app.use(i18n);
}

// Using a wrapper function to avoid excessive type instantiation depth
export function $t(key: string, ...args: any[]): string {
    return globalT(key, ...args);
}

export function setLocale(locale: App.I18n.LangType) {
    i18n.global.locale.value = locale;
}

export const currentLocal = computed(() => localStg.get('lang') || 'fa-IR')